import { STATUS as _STATUS } from "../Constants";
import { FindingSTATUS as _FindingSTATUS } from "../Constants";

function hasUserProfile(User) {
	if (User != null && User.roles != null && (User.roles.includes("Data Approver") || User.roles.includes("Division Manager") || User.roles.includes("Compiler") || User.roles.includes("Administrator"))) {
		return true;
	}
	return false;
}

export function IsInRole(User, Role) {
	if (User != null && User.roles != null && hasUserProfile(User)) {
		if (Role != null) return User.roles.includes(Role);
		return true;
	}
	return false;
}

export function IsEnabled(User, Module) {
	if (User != null && User.modules != null && User.modules.length > 0) return User.modules.includes(Module);
}

export function IsEditable(Module, Process, User, Status, SectionOrField, Resource) {
	// Resource è un oggetto, che deve contenere il campo richiesto dalla policy, da confrontare con l'idUser loggato(es. Resource.idCompiler == User.id)
	// console.log({ Module, Process, User, Status, SectionOrField, Resource });
	if (Status == null) return false;
	const workflows = User.policies;
	const { roles } = User;

	if (Resource?.email != null) {
		//RITM0547372;
		roles.push("CAR Owner");
	}
	const workflow = workflows.find((p) => p.module == Module && p.process == Process);
	if (workflow != null) {
		// multi roles support
		for (let i = 0; i < roles.length; i += 1) {
			const policy = workflow.policies.find((p) => p.role == roles[i]);
			if (policy != null && policy.data != null) {
				const data = policy.data.find((a) => a.sections.includes(SectionOrField) && (Process == 'FindingManagement' ? _FindingSTATUS[a.status] == Status : _STATUS[a.status] == Status));
				const propertyName = policy.requireResource;
				if (propertyName) {
					if (Resource != null) {
					 	if (Process == 'FindingManagement') {
							if (Resource[propertyName] != null) {
								if (Array.isArray(Resource[propertyName])) {
								  if (Resource[propertyName].find(el => User?.id === el ) || Resource[propertyName].find(el => el.toString().toLowerCase() == User.email.toLowerCase()) ) { 
									if (data != null) return true;
								  }
								}
								else { 
									if (Resource[propertyName].toLowerCase() == User?.id?.toLowerCase() || Resource[propertyName].toLowerCase() == User.email.toLowerCase()) {
										if (data != null) return true;
									}
								}
							}
						}
						else {
							if (Resource[propertyName] != null && (Resource[propertyName].toLowerCase() == User?.id?.toLowerCase() || Resource[propertyName].toLowerCase() == User.email.toLowerCase())) { //RITM0710913
								if (data != null) return true;
							}
						}
					}
				} else if (data != null) return true;
			}
		}
		return false;
	}
	return false;
}
export function CanExecuteAction(Module, Process, User, Status, ActionType, Resource, OptionalResource = null) {
	// console.log({ Module, Process, User, Status, ActionType, Resource });
	if (Status == "") {
		Status = undefined;
	} // in creazione lo status è null

	const workflows = User.policies;
	const { roles } = User;

	const workflow = workflows.find((p) => p.module == Module && p.process == Process);
	if (workflow != null) {
		// multi roles support
		for (let i = 0; i < roles.length; i += 1) {
			const policy = workflow.policies.find((p) => p.role == roles[i]);
			if (policy != null) {
				const action = policy.actions.find((a) => a.type == ActionType && (Process == 'FindingManagement' ? _FindingSTATUS[a.status] == Status : _STATUS[a.status] == Status));
				const propertyName = policy.requireResource;
				if (propertyName) {
					if (Resource != null) {
						if (Process == 'FindingManagement') {
						   if (Resource[propertyName] != null) {
							   if (Array.isArray(Resource[propertyName])) {
								 if (Resource[propertyName].find(el => User?.id === el ) || Resource[propertyName].find(el => el.toString().toLowerCase() == User.email.toLowerCase()) ) { 
									if (action != null) return true;
								 }
							   }
							   else { 
								   if (Resource[propertyName].toLowerCase() == User?.id?.toLowerCase() || Resource[propertyName].toLowerCase() == User.email.toLowerCase()) {
									if (action != null) return true;
								   }
							   }
						   }
					   }
					   else {
						   if (Resource[propertyName] != null && (Resource[propertyName].toLowerCase() == User?.id?.toLowerCase() || Resource[propertyName].toLowerCase() == User.email.toLowerCase())) { //RITM0710913
							if (action != null) return true;
						   }
					   }
				   }

					//check if the auditor is a team leader RITM0736117
					if(ActionType === 'Submit' && Status == 1){
						if(OptionalResource != null) {
							const found = OptionalResource.find(item =>  item[propertyName] != null && item[propertyName].toLowerCase() == User.email.toLowerCase() && item['teamLeader'] != null && item['teamLeader'] == true);
							if (found != null)
								return true;
						}
					}					
				} else if (action != null) return true;
			}
		}
		return false;
	}
	return false;
}
